import React from 'react';
import { t } from 'i18n';

import Button from 'Components/Base/Button'
import { ModalFooter } from 'Components/Base'
import { Modal } from 'Components/Base/Modal'

const i18nOpts = { scope: 'care_plan_creators.check_in_templates.questions' }

const DeleteDialog = ({
  isOpen,
  handleDelete,
  closeModal,
}) => {
  return <>
    <Modal isOpen={isOpen} closeModal={closeModal}>
      <h4 className="text-grey-darkest header">{t('confirmation', i18nOpts)}</h4>
      <ModalFooter
        renderRight={() => (
          <>
            <Button
              text={t('cancel', i18nOpts)}
              className="btn btn--secondary"
              onClick={closeModal}
            />
            <Button text={t('delete', i18nOpts)} onClick={handleDelete} />
          </>
        )}
      />
    </Modal>
  </>;
};

export default DeleteDialog;
